/** Quantity accepted on a partial line. The remainder of the row is cancelled. */
export const parsePartialCount = (raw: string, total: number): number | null => {
    const trimmed = String(raw ?? '').trim();
    if (!/^\d+$/.test(trimmed)) return null;
    const value = Number(trimmed);
    const line = Number(total);
    if (!Number.isInteger(value) || !Number.isInteger(line)) return null;
    if (value <= 0 || value >= line) return null;
    return value;
};
